import type { CityConfig } from "../city-template/types";

export const minotConfig: CityConfig = {
  city: "Minot",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "minot",
  route: "/cities/minot",
  title: "Emergency Passport Minot, ND — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Minot, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Minot, Minot AFB, Ward County, and Bakken region travelers. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Minot, ND",
  heroSubtitle: "Minot AFB deployment or PCS orders overseas? Bakken oil field business trip to Canada or the Middle East? Norsk Hostfest performers and visitors coming from Scandinavia? We help Minot residents — from Air Force families at Minot AFB to Bakken energy professionals to Scandinavian festival organizers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Minot%20North%20Dakota%20skyline%20with%20the%20Souris%20River%20winding%20through%20the%20city%20and%20rolling%20prairie%20landscape%20in%20the%20background%2C%20downtown%20historic%20buildings%20mixed%20with%20modern%20development%2C%20dramatic%20North%20Dakota%20big%20sky%20at%20golden%20hour%20with%20warm%20amber%20light%20over%20the%20plains%2C%20editorial%20travel%20photography%20style%20with%20crisp%20detail%20and%20natural%20colors%2C%20no%20people%20visible&width=1800&height=700&seq=minot-hero-2026&orientation=landscape",
  heroImageAlt: "Minot North Dakota skyline with Souris River and prairie at golden hour",
  geoPosition: "48.2325;-101.2963",
  geoPlacename: "Minot, North Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 580 miles from Minot; not practical for most Ward County residents",
  },
  nearbyCitiesZips: [
    { name: "Minot", zips: "58701, 58703, 58704" },
    { name: "Minot AFB", zips: "58705" },
    { name: "Burlington", zips: "58722" },
    { name: "Surrey", zips: "58785" },
    { name: "Berthold", zips: "58718" },
    { name: "Velva", zips: "58790" },
    { name: "Kenmare", zips: "58746" },
    { name: "Rugby", zips: "58368" },
  ],
  benefits: [
    { icon: "ri-global-line", title: "Minot AFB Military Passport Expertise", desc: "Minot Air Force Base is home to B-52 bomber and Minuteman III missile wings with frequent deployments and PCS moves overseas. We understand military passport timelines and handle official and tourist passport needs for service members and their families." },
    { icon: "ri-flight-takeoff-line", title: "MOT Minot International Airport", desc: "Connecting flights to Minneapolis, Denver, and Las Vegas for international departures. We coordinate passport timelines around your MOT connection — your passport should be valid when you check in at Minot, not just at your international gateway." },
    { icon: "ri-building-2-line", title: "No Minneapolis Trip Needed", desc: "Minneapolis Passport Agency is 580 miles away — completely impractical for Minot residents. Our registered courier service handles everything remotely so you never leave North Dakota." },
    { icon: "ri-home-2-line", title: "Bakken Energy + Scandinavian Heritage", desc: "Bakken oil field professionals traveling internationally for energy conferences and equipment sourcing, plus Norsk Hostfest's global Scandinavian connections — we understand Minot's unique international travel profile." },
  ],
  internalLinks: [
    { name: "Expedited passport in Fargo, ND", route: "/cities/fargo" },
    { name: "Fast passport services in Bismarck, ND", route: "/cities/bismarck" },
    { name: "Quick passport services in Grand Forks, ND", route: "/cities/grand-forks" },
    { name: "Urgent passport services in Williston, ND", route: "/cities/williston" },
    { name: "North Dakota passport services overview", route: "/states/north-dakota" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Minot via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 9+ hours to Minnesota. Minot residents can ship from any UPS Store, FedEx Office, or post office location across Ward County.",
  fpcOfficeDistance: "Serving Minot, Minot AFB, Burlington, Surrey, Berthold, Velva, Kenmare, Rugby, and all Ward County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Minot and the Magic City region. From the Minot AFB military community to the Bakken energy corridor, from the downtown business district to the North Dakota State Fairgrounds — we serve all of Ward County. Our courier service eliminates the need to drive 580 miles to Minneapolis for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Minot and all Ward County communities including Minot AFB, Burlington, Surrey, and Berthold. We also serve Bakken oil field workers stationed in the region, Minot AFB military families, and the Scandinavian-American community centered around Norsk Hostfest.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Minot as simple as possible — with the efficiency Bakken energy professionals, Minot AFB military families, and Magic City travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Minot travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Minot travelers encounter unique passport issues — from military deployment documentation to Bakken international travel timing to North Dakota rural mail delivery. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Magic City travelers — from Minot AFB families to Bakken energy professionals to Norsk Hostfest organizers — trust us when their international departure is days away and Minneapolis is simply not an option.",
  faqIntro: "Have questions about expedited passports in Minot, ND? Here are the most common ones we hear from Magic City travelers.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you need a renewal before a PCS move to an overseas base, an emergency passport for a last-minute MOT international connection, or a first-time passport for a Scandinavian heritage trip — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for upcoming international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Minot", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 580 miles from Minot", "Completely impractical for Ward County residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "MOT flight connecting to international deployment or business trip in 2 days? Urgent family travel to Canada? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Minot travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Minot residents renew fast — no agency visit required for most renewals. Perfect for Minot AFB families, Bakken professionals, and Magic City residents traveling abroad.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Ward County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your PCS move or MOT international connection is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Minot AFB family move or Magic City family vacation abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for Minot AFB families after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Bakken energy executives traveling while primary passport is in visa processing, and military contractors with overlapping international assignments.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Ward County travelers through the process so your international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Minot residents crossing into Saskatchewan and Manitoba regularly.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Minot ND", description: "Urgent passport processing for Minot North Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Minot ND", description: "Fast passport renewal for Minot North Dakota residents." },
    { name: "First-Time Passport Minot ND", description: "New passport application services for Minot North Dakota first-time applicants." },
    { name: "Child Passport Minot ND", description: "Minor passport services for Minot North Dakota families with children under 16." },
    { name: "Name Change Passport Minot ND", description: "Passport name correction for Minot residents after marriage or legal name changes." },
    { name: "Second Passport Minot ND", description: "Second passport services for Minot frequent travelers and energy professionals." },
  ],
  testimonials: [
    {
      name: "Capt. James R.",
      location: "Minot AFB",
      rating: 5,
      text: "Got PCS orders to Germany with a short turnaround — my family needed passports renewed and my daughter needed her first one. Fast Passport Center handled all four applications remotely, and we had our passports before the movers even arrived. A lifesaver for military families in North Dakota.",
      service: "Family Passport — PCS Move",
    },
    {
      name: "Carla M.",
      location: "Minot",
      rating: 5,
      text: "I work in the Bakken and had a last-minute equipment sourcing trip to Calgary. My passport had expired and I only had 8 days. They expedited it without me driving to Minneapolis — which was never going to happen. Got my passport in 4 days. Incredible.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Larson Family",
      location: "Minot",
      rating: 5,
      text: "We planned a Norsk Hostfest performers trip to Norway — a heritage tour that meant the world to our family. When our kids' passports were expired 3 weeks before departure, Fast Passport Center got everything done in time. They understood what this trip meant.",
      service: "Child Passport — Family",
    },
    {
      name: "Mike D.",
      location: "Burlington",
      rating: 5,
      text: "Energy industry contractor heading to the Middle East on short notice. Needed a passport renewal and a second passport for overlapping travel. Fast Passport Center handled both applications seamlessly. Being in rural North Dakota, having a courier that works remotely is priceless.",
      service: "Passport Renewal + Second Passport",
    },
  ],
  facilities: [
    {
      id: "minot-1",
      name: "Minot Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 1st St SW",
      city: "Minot",
      state: "ND",
      zip: "58701",
      phone: "(701) 852-6717",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Downtown Minot",
      website: "https://tools.usps.com/find-location.htm?location=1378262",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Ward County. Passport photos available on-site. Appointment recommended — schedule at least a week in advance during summer and holiday seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "minot-2",
      name: "Minot AFB Military Personnel Flight",
      type: "Military Passport Acceptance Facility",
      address: "Minot AFB — 5th Force Support Squadron",
      city: "Minot AFB",
      state: "ND",
      zip: "58705",
      phone: "(701) 723-3446",
      hours: "Mon-Fri 7:30 AM - 4:30 PM (active duty and dependents only)",
      distance: "Minot AFB — about 13 miles north of Minot",
      website: "https://www.minot.af.mil/",
      websiteLabel: "Minot AFB Website",
      notes: "Serves active duty military personnel and their dependents at Minot AFB. Handles official and tourist passport applications. Check with MPF for specific requirements and appointment availability.",
      icon: "ri-shield-line",
    },
    {
      id: "minot-3",
      name: "Ward County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "315 3rd St SE, Suite 201",
      city: "Minot",
      state: "ND",
      zip: "58701",
      phone: "(701) 857-6460",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Downtown Minot — Ward County Courthouse",
      website: "https://www.wardnd.com/",
      websiteLabel: "Ward County Website",
      notes: "Alternative to post office acceptance. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "minot-4",
      name: "Rugby Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 2nd St NW",
      city: "Rugby",
      state: "ND",
      zip: "58368",
      phone: "(701) 776-6111",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Rugby — about 63 miles east of Minot",
      website: "https://tools.usps.com/find-location.htm?location=1384732",
      websiteLabel: "USPS Location",
      notes: "Serves Pierce County and eastern Ward County residents. Call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "minot-5",
      name: "Williston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E Broadway",
      city: "Williston",
      state: "ND",
      zip: "58801",
      phone: "(701) 572-4050",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Williston — about 130 miles west of Minot",
      website: "https://tools.usps.com/find-location.htm?location=1388511",
      websiteLabel: "USPS Location",
      notes: "Serves Bakken region and Williams County. Larger facility with regular passport acceptance hours. About 2 hours from Minot — useful for combined trip for other errands.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 580 miles and 9+ hour drive from Minot", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Minneapolis; completely impractical for Ward County residents", fpc: "Most Minot travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, even more problematic from rural ND", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Minot", agency: "580-mile drive to Minneapolis one way — completely impractical for ND residents", fpc: "Entirely remote — forms online, ship from Minot, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Minneapolis, time off, logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "Minot Context", agency: "No Minot-specific guidance — no AFB, Bakken, or rural ND expertise", fpc: "Full Minot knowledge — Minot AFB, Bakken energy, rural mail, cross-border Canada" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Military Deployment Passport Documentation Gaps",
      description: "Minot AFB service members with PCS orders overseas need passports on tight timelines. Official passports have different requirements than tourist passports. We help military families navigate both types and coordinate processing with deployment schedules.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Bakken Travel to Canada Without Valid Passport",
      description: "Bakken oil field professionals often drive to Saskatchewan and Alberta for equipment sourcing, meetings, and site visits. Many assume a North Dakota enhanced driver's license is sufficient — but a valid passport or passport card is still required for most Canadian border crossings.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Rural Mail Timing Miscalculations",
      description: "Rural Ward County mail delivery can take 1-3 extra days. When timing passport processing around PCS dates or international business trips, standard mail creates unacceptable risk. Our overnight courier channel eliminates rural mail delays.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Some local North Dakota pharmacies produce passport photos that don't meet strict State Department standards for background color, lighting, and dimensions. We catch this during document review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Norsk Hostfest International Travel Rush",
      description: "Norsk Hostfest brings performers and visitors from across Scandinavia every fall. Minot residents traveling to Norway, Sweden, and Denmark for reciprocal cultural visits often realize their passports are expired just weeks before departure. Starting passport processing 4+ weeks before Norsk Hostfest season is recommended.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a PCS move, Bakken business trip, or Scandinavian heritage tour." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're at Minot AFB, in the Bakken, or a Magic City resident." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Minot clients ship from the UPS Store on South Broadway or the Minot Post Office — no Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Minot travelers never need to drive to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Minot address — whether that's on base, in the Bakken, or downtown. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Minot, North Dakota?", a: "We offer Minot-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because Minot's nearest regional passport agency is in Minneapolis (580 miles away), our remote courier service is the most practical fast option in northwestern North Dakota." },
    { q: "Do I need to visit a Minot office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Minot Post Office, Ward County Clerk, or Minot AFB MPF for military), then ship documents overnight. We handle State Department submission and return your passport to your Ward County address." },
    { q: "Can Minot AFB personnel get expedited passports for PCS moves?", a: "Yes. We work with Minot AFB service members and families on PCS orders every rotation. Official (no-fee) passports have different requirements from tourist passports — we guide you through which applies to your orders. Our courier channel processes tourist passports faster than standard military channels when PCS timelines are compressed." },
    { q: "What if I need a passport and Minneapolis is too far?", a: "Minneapolis Passport Agency is 580 miles from Minot — a 9+ hour drive through rural Minnesota. That's why our registered courier service is the best expedited option in northwestern North Dakota. We handle the agency submission remotely, so you never leave the Magic City." },
    { q: "What is the best price for expedited passport service in Minot?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Minot applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. Military families: we provide guidance on additional requirements for PCS-related passports." },
    { q: "Can Bakken oil field workers get fast passports for Canada travel?", a: "Yes. Bakken energy professionals crossing into Saskatchewan and Alberta are frequent clients. A passport card works for land crossings to Canada and processes faster than a full passport book. We expedite both types of documents for oil field travel timelines." },
    { q: "Can I get a passport photo in Minot?", a: "Yes. The Minot Post Office offers on-site passport photos. CVS, Walgreens, and Walmart in Minot also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does rural mail delivery affect passport processing from Minot?", a: "Rural Ward County mail routes can add 1-3 extra days to standard delivery. We use overnight courier shipping to eliminate rural mail delays — your documents arrive at our processing center the next business day, and your completed passport is returned with the same speed." },
    { q: "Can you help with passports for Norsk Hostfest international travel?", a: "Yes. Norsk Hostfest brings the world to Minot every fall, and many Magic City residents travel to Scandinavia for reciprocal cultural visits. We process expedited passports for these heritage trips. Our recommendation: start the process 4+ weeks before your planned departure to Norway, Sweden, or Denmark." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Minot Residents",
    intro: "Minot's position in northwestern North Dakota — home to Minot AFB, the Bakken oil fields, and the Norsk Hostfest — creates unique passport timing needs. Here's what Magic City travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "MOT — Minot International Airport",
        subtitle: "Minot's regional airport connecting to major hubs",
        description: "MOT serves northwestern North Dakota with daily flights to Minneapolis, Denver, and Las Vegas. Most Minot international travelers connect through Minneapolis-St. Paul (MSP) for overseas flights. The airport sees significant military traffic from Minot AFB and energy sector travelers from the Bakken — both groups with unique passport timing needs.",
        tip: "MOT connections to MSP mean your passport needs to be valid at Minot check-in, not at Minneapolis. Many travelers overlook this and discover passport issues at the MOT counter rather than at their international gateway.",
      },
      {
        icon: "ri-shield-line",
        title: "Minot AFB — Deployments & PCS Moves",
        subtitle: "Military families with compressed international timelines",
        description: "Minot Air Force Base supports two major missions — B-52 strategic bombers and Minuteman III intercontinental ballistic missiles. Service members and their families face frequent PCS moves, including overseas assignments, and deployments with tight turnaround times. Tourist passports for family members and official passports for service members both need expedited processing that doesn't require a Minneapolis trip.",
        tip: "Minot AFB families should check all passports — tourist and official — at least 90 days before DEROS or PCS dates. Our courier channel can close gaps when official processing timelines are compressed.",
      },
      {
        icon: "ri-oil-line",
        title: "Bakken Energy International Travel",
        subtitle: "Oil field professionals with global business needs",
        description: "The Bakken formation has made Minot a hub for energy professionals who travel internationally — to Canada for field operations and equipment sourcing, to the Middle East for energy conferences, and to Europe for technology partnerships. These travelers need reliable fast passport service from a location where Minneapolis is a full day's drive away.",
        tip: "Bakken professionals with international travel should maintain at least 6 months of passport validity and consider a second passport if their primary passport spends significant time with visa applications for multiple countries.",
      },
      {
        icon: "ri-earth-line",
        title: "Norsk Hostfest & Scandinavian Connections",
        subtitle: "North America's largest Scandinavian festival creates global travel patterns",
        description: "Norsk Hostfest attracts performers, artists, and visitors from Norway, Sweden, Denmark, Iceland, and Finland to Minot every fall. The festival creates reciprocal travel as Minot residents visit Scandinavia for cultural exchanges, heritage tours, and return performances. This concentrated fall travel creates a predictable passport demand spike each year.",
        tip: "Minot residents planning Norsk Hostfest-related travel to Scandinavia should start passport processing by August for September-October departures. Heritage tour groups should coordinate passport checks for all members well in advance.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Minot & the Canadian Border Corridor",
      description: "Minot sits just 60 miles south of the Canadian border, with Saskatchewan and Manitoba within easy driving distance. The Portal/North Portal border crossing on US-52 is the primary route into Saskatchewan, connecting Minot to Estevan, Regina, and beyond. Cross-border travel for shopping, business, and family is woven into daily life in northwestern North Dakota — creating steady demand for reliable passport and passport card services.",
    },
  },
  destinations: {
    title: "Where Minot Travelers Go — And Why Passports Get Urgent",
    intro: "Minot's military, energy, and cultural identity shapes its international travel patterns. Here are the most common destinations and urgency scenarios we see.",
    stats: [
      { stat: "35%", label: "of Minot expedited requests involve military PCS moves or deployments" },
      { stat: "3-4 Weeks", label: "average lead time from trip booking to departure for Magic City travelers" },
      { stat: "Aug-Oct", label: "peak season for Norsk Hostfest travel and fall military moves" },
      { stat: "580 Miles", label: "distance to nearest passport agency in Minneapolis — our courier bridges this" },
    ],
    destinations: [
      { name: "Canada", context: "Saskatchewan and Manitoba business travel, Bakken equipment sourcing, Calgary and Edmonton energy conferences, family visits across the border", urgency: "Year-round steady demand from cross-border business and family travel", icon: "ri-map-pin-2-line" },
      { name: "Germany & Europe", context: "Minot AFB PCS assignments to Ramstein and other European bases, Ramstein and Spangdahlem, energy technology partnerships in the UK and Norway", urgency: "PCS orders with fixed report dates — typically 60-90 day turnaround", icon: "ri-map-pin-2-line" },
      { name: "Scandinavia", context: "Norsk Hostfest reciprocal travel to Norway, Sweden, Denmark, heritage and genealogy tours, cultural exchange programs", urgency: "September-October peak for fall festival season travel", icon: "ri-map-pin-2-line" },
      { name: "Middle East", context: "Bakken energy conferences and operations, military deployments, contractor assignments in UAE, Saudi Arabia, and Qatar", urgency: "Deployment and contract timelines with 2-4 week turnaround", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Minot AFB PCS to Japan and South Korea, Bakken technology partnerships in China, connections through Minneapolis and Denver", urgency: "PCS orders and procurement trips with fixed dates", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter getaways from North Dakota's brutal cold season, resort vacations, cruise departures through MSP connections", urgency: "Fall bookings as winter approaches and residents plan warm escapes", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Peace Garden State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Fargo", route: "/cities/fargo" },
      { name: "Bismarck", route: "/cities/bismarck" },
      { name: "Grand Forks", route: "/cities/grand-forks" },
    ],
  },
  photoLocations: [
    { name: "Minot Post Office", address: "115 1st St SW, Minot, ND 58701", hours: "Mon-Fri 9 AM - 4 PM (photo service available)" },
    { name: "CVS Pharmacy — Minot", address: "1930 S Broadway, Minot, ND 58701", hours: "Daily 8 AM - 9 PM" },
    { name: "Walgreens — Minot", address: "105 20th Ave SW, Minot, ND 58701", hours: "Daily 8 AM - 10 PM" },
    { name: "Walmart Supercenter — Minot", address: "3900 S Broadway, Minot, ND 58701", hours: "Daily 6 AM - 11 PM" },
    { name: "The UPS Store — Minot", address: "1515 S Broadway, Minot, ND 58701", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "North Dakota DOT — Minot Driver License Office",
      address: "221 22nd Ave NW, Minot, ND 58703",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Located at the North Dakota State Fair Center complex.",
      featured: true,
    },
    {
      name: "Ward County Treasurer — Motor Vehicle",
      address: "315 3rd St SE, Minot, ND 58701",
      hours: "Mon-Fri, 8:00 AM - 4:30 PM",
      note: "Vehicle registration and title services. For driver licenses, visit the ND DOT office on 22nd Ave NW.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MOT",
      name: "Minot International Airport",
      distance: "About 2 miles north of downtown Minot",
      address: "305 Airport Rd, Minot, ND 58703",
      note: "Serves northwestern North Dakota with daily flights to Minneapolis, Denver, and Las Vegas. Primary air gateway for Minot AFB personnel, Bakken energy travelers, and Magic City residents connecting to international flights.",
      flightUrl: "https://www.motairport.com/",
      flightLabel: "Minot Airport Website",
      featured: true,
    },
    {
      code: "BIS",
      name: "Bismarck Airport",
      distance: "About 110 miles south of Minot (1 hour 45 minutes via US-83)",
      address: "2301 University Dr, Bismarck, ND 58504",
      note: "Larger regional airport with additional connections. Alternative for Minot travelers needing more flight options or different airlines.",
      flightUrl: "https://www.bismarckairport.com/",
      flightLabel: "Bismarck Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through ND Department of Health Vital Records. Required for estate and legal matters in Ward County.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Ward County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://www.wardnd.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Ward County District Court. Required for name change passport corrections.",
      url: "https://www.wardnd.com/",
    },
  ],
};